<div class="requests-container" *ngIf="communicationRequestChats != null; else noRequests">
  <div class="search-bar">
    <nz-input-group [nzPrefix]="prefixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search"
        [formControl]="searchControl"
      />
    </nz-input-group>

    <ng-template #prefixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>

  <div class="requests-list">
    <div
      *ngFor="let requestChat of communicationRequestChats"
      class="request-item"
      (click)="onRequestClick(requestChat)"
    >
      <div class="request-content">
        <div class="icon-wrapper">
          <i
            nz-icon
            nzType="file-text"
            class="icon"
            [ngClass]="{ 'text-primary': requestChat.isActive == true }"
          ></i>
        </div>

        <div class="request-name">{{ requestChat.frontOfficeApplicationId }}</div>
      </div>

      <nz-badge
        nzStandalone
        [nzCount]="requestChat?.unreadMessagesCount"
        nzSize="small"
      />
    </div>
  </div>

  <!-- FOOTER (pagination + button) -->
  <div class="requests-footer" *ngIf="total > (request.pageSize ?? 10)">
    <div class="requests-pagination">
      <nz-pagination
        [nzPageIndex]="(request.pageNumber ?? 0) + 1"
        [nzTotal]="total"
        [nzPageSize]="request.pageSize ?? 10"
        [nzShowSizeChanger]="false"
        [nzPageSizeOptions]="[10, 20, 50]"
        [nzShowQuickJumper]="false"
        [nzSize]="'small'"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      >
      </nz-pagination>
    </div>

    <!-- <div class="footer-button">
      <button nz-button nzType="primary" (click)="onGoSubmitRequest()">
        Submit request
      </button>
    </div> -->
  </div>
</div>

<ng-template #noRequests>
  <div class="requests-empty">
    <div class="requests-empty-content">
      <i nz-icon nzType="comment" class="empty-icon"></i>
      <div class="empty-title"><b>There are no requests</b></div>
      <div class="empty-desc">Your requests will be shown here.</div>
      <!-- <button nz-button nzType="primary" (click)="onGoSubmitRequest()">
        Submit request
      </button> -->
    </div>
  </div>
</ng-template>
